import type { Persister } from "@tanstack/react-query-persist-client";

import { db } from "../../storage/indexed-db/database";

export const indexedDbPersister: Persister = {
  persistClient: async (client) => {
    await db.queryCache.put({ key: "tanstack-query", value: client });
  },
  restoreClient: async () => {
    const started = performance.now();
    const client = await db.queryCache.get("tanstack-query");
    performance.measure("erp.cache.restore", {
      start: started,
      end: performance.now(),
    });
    return client?.value;
  },
  removeClient: async () => {
    await db.queryCache.delete("tanstack-query");
  },
};
